import { render, staticRenderFns } from "./SectionRowProfile.vue?vue&type=template&id=6ab74605&"
import script from "./SectionRowProfile.vue?vue&type=script&lang=ts&"
export * from "./SectionRowProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports